import createCache from "@emotion/cache";
import { EmotionCache } from "@emotion/react";

export const createEmotionCache = (): EmotionCache =>
  createCache({ key: "css" });

// https://github.com/FirebaseExtended/reactfire/discussions/228#discussioncomment-182830
// Prevent "Missing or insufficient permissions"
export const clearFirestoreCache = () => {
  const map = globalThis["_reactFirePreloadedObservables"];
  Array.from(map.keys()).forEach(
    (key: string) => key.includes("firestore") && map.delete(key)
  );
};

export type GooglePlaceUrlProps = {
  query: string;
  placeId?: string;
};
/**
 * Build a google maps url given a placeId and query, or an address.
 * https://developers.google.com/maps/documentation/urls/get-started#search-action
 */
export const googlePlaceUrl = (params: GooglePlaceUrlProps) => {
  const googleMapsUrl = new URL("https://www.google.com/maps/search/");
  googleMapsUrl.searchParams.append("api", "1");
  googleMapsUrl.searchParams.append("query", params.query);

  if (params.placeId) {
    googleMapsUrl.searchParams.set("query_place_id", params.placeId);
  }

  return googleMapsUrl.toString();
};
